<template>
  <div :v-if="isInRole(['admin'])">
    <toolbar />
    <zlick-navigation />
    <v-container>
      <v-layout row wrap center>
        <v-flex xs12 offset-xs0>
          <v-form ref="addUser" lazy-validation>
            <v-text-field
              type="email"
              name="user_email"
              v-model="user_email"
              validate-on-blur
              :rules="[v => !!v || $t('email_required')]"
              :label="$t('user_email')"
              :placeholder="$t('placeholderemail')"
              required
            />
          <v-select
                  v-model="roles"
                  :items="options"
                  :menu-props="{ maxHeight: '400' }"
                  label="Roles"
                  :placeholder="$t('placeholderrole')"
                  multiple
                  chips
                ></v-select>
            <v-btn @click="addUser">{{ $t('updateuser') }}</v-btn>
            <v-btn @click="back">{{ $t("back") }}</v-btn>
            <br />
            <br />
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Bugsnag from '../services/Bugsnag'
import AuthenticationService from '../services/AuthenticationService'
import ZlickNavigation from './ZlickNavigation'
import Toolbar from './Toolbar'
import UserManagementService from '../services/UserManagementService'

export default {
  components: {
    Toolbar,
    ZlickNavigation
  },
  data () {
    return {
      valid: true,
      user_email: '',
      options: ['admin', 'techsupport', 'support', 'telemarketing', 'analyst'],
      roles: '',
      user_name: '',
      error: null
    }
  },
  mounted () {
    var roles = []
    var email = localStorage.getItem('editUserEmail')
    roles = localStorage.getItem('editUserRoles').split(',')
    this.user_email = email
    this.roles = roles
  },
  beforeCreate () {
    if (!AuthenticationService.isUserLoggedIn()) {
      this.$router.push('/login')
      return
    }
    if (!AuthenticationService.isInRole(['admin', 'support', 'analyst'])) {
      this.$router.push('/telemarketing')
    }
  },
  methods: {
    clear () {
      this.user_email = ''
      this.user_name = ''
      this.roles = ''
    },
    isInRole (roles) {
      return AuthenticationService.isInRole(roles)
    },
    formatUserInfo (attributes, key) {
      for (const attribute of attributes) {
        if (attribute.Name === 'email' & key === 'email') {
          return attribute.Value.toString()
        }
        if (attribute.Name === 'custom:role' & key === 'role') {
          let values = []
          values.push(attribute.Value.split(' '))
          return values.join(',  ')
        }
      }
    },
    back () {
      localStorage.removeItem('editUserEmail')
      localStorage.removeItem('editUserRoles')
      this.$router.push('/manageusers')
    },
    async addUser () {
      try {
        await UserManagementService.updateRoles(this.user_email, this.roles)
        this.$toast.success('Successfully done')
        this.back()
        return
      } catch (error) {
        this.$toast.error(error.message)
        Bugsnag.send(error)
        this.back()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/editUser.vue